let cachedTimezone: string | null = null

export function setTimezone(timezone: string | undefined | null) {
  if (typeof timezone === 'string' && timezone.trim().length > 0) {
    cachedTimezone = timezone
  }
}

export function getTimezone(): string {
  if (cachedTimezone) return cachedTimezone
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    return tz || 'UTC'
  } catch (_e) {
    return 'UTC'
  }
}
